document.addEventListener("DOMContentLoaded", () => {
    // Get relevant elements and collections
    const tabbed = document.querySelector(".c-tabbed");
    if (!tabbed) return;
    const tablist = tabbed.querySelector("ul");
    if (!tablist) return;
    const tabs = tablist.querySelectorAll("a");
    const panels = tabbed.querySelectorAll('[id^="section"]') as NodeListOf<HTMLElement>;

    // The tab switching function
    const switchTab = <T extends HTMLElement, U extends HTMLElement>(oldTab: T, newTab: U) => {
        
        const tabLink = newTab.getAttribute("href");
        if (tabLink != null && !tabLink.startsWith('#'))
        {
            window.location.assign(tabLink);
            return;
        }
        
        newTab.focus();
        // Make the active tab focusable by the user (Tab key)
        newTab.removeAttribute("tabindex");
        // Set the selected state
        newTab.setAttribute("aria-selected", "true");
        oldTab.removeAttribute("aria-selected");
        // oldTab.setAttribute("tabindex", "-1");
        // Get the indices of the new and old tabs to find the correct
        // tab panels to show and hide
        let index = Array.prototype.indexOf.call(tabs, newTab);
        let oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
        panels[oldIndex].hidden = true;
        panels[index].hidden = false;
    };

    // Add the tablist role to the first <ul> in the .tabbed container
    tablist.setAttribute("role", "tablist");

    // Add semantics are remove user focusability for each tab
    Array.prototype.forEach.call(tabs, <T extends HTMLElement>(tab: T, i: number) => {
        tab.setAttribute("role", "tab");
        tab.setAttribute("id", "tab" + (i + 1));
        // tab.setAttribute("tabindex", "-1");
        if(tab.parentNode && tab.parentNode instanceof HTMLElement) tab.parentNode.setAttribute("role", "presentation");

        // Handle clicking of tabs for mouse users
        tab.addEventListener("click", (e: MouseEvent) => {
            e.preventDefault();
            let currentTab = tablist.querySelector("[aria-selected]") as HTMLAnchorElement;
            if (e.currentTarget && e.currentTarget instanceof HTMLElement && e.currentTarget !== currentTab) {
                switchTab(currentTab, e.currentTarget);
            }
        });

        // Handle keydown events for keyboard users
        tab.addEventListener("keydown", (e) => {
            const target = e.currentTarget as HTMLElement;
            // Get the index of the current tab in the tabs node list
            let index = Array.prototype.indexOf.call(tabs, target);
            // Work out which key the user is pressing and
            // Calculate the new tab's index where appropriate
            let dir =
                e.which === 37
                    ? index - 1
                    : e.which === 39
                        ? index + 1
                        : e.which === 40
                            ? "down"
                            : null;
            if (dir !== null) {
                e.preventDefault();
                // If the down key is pressed, move focus to the open panel,
                // otherwise switch to the adjacent tab
                dir === "down"
                    ? panels[i].focus()
                    : tabs[dir]
                        ? switchTab(target, tabs[dir])
                        : void 0;
            }
        });
    });

    // Add tab panel semantics and hide them all
    Array.prototype.forEach.call(panels, <T extends HTMLElement>(panel: T, i: number) => {
        panel.setAttribute("role", "tabpanel");
        // panel.setAttribute("tabindex", "-1");
        let id = panel.getAttribute("id");
        panel.setAttribute("aria-labelledby", tabs[i].id);
        panel.hidden = true;
    });

    // Initially activate the first tab and reveal the first tab panel
    let tabIndex = 0;
    if (window.location.hash) {
        let activeTab = Array.from(tabs).find((element) => element.getAttribute('href') === window.location.hash);
        if (activeTab){
            tabIndex = Array.from(tabs).indexOf(activeTab);
        }
    }
    else {
        let activeTab = Array.from(tabs).find((element) => element.getAttribute('aria-selected') === 'true');
        if (activeTab) {
            tabIndex = Array.from(tabs).indexOf(activeTab);
        }
    }

    tabs[tabIndex].removeAttribute("tabindex");
    tabs[tabIndex].setAttribute("aria-selected", "true");
    if (panels && panels.length > 0) {
        panels[tabIndex].hidden = false;
    }
});